import { createAsyncThunk } from '@reduxjs/toolkit'
import { cashOutBetHiLoService, myBetsHiLoService, getUnfinishedBetService, openCardHiLoService, placeBetHiLoService } from '../services/hiloGame.service'
import { BET_RESULT } from 'constants/index'
import { setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { openErrorToaster, openSuccessToaster } from 'helpers/toaster.helpers'
import { resetCalculatedProfits, setCalculatedProfits } from './hiLoGame.slice'

export const placeBetHiLo = createAsyncThunk('hi-lo-game/place-bet', async ({ payload, buttonClickAudio }, thunkApi) => {
  try {
    const res = await placeBetHiLoService(payload)
    const { onSuccess } = payload
    const { gameSound } = thunkApi?.getState()?.gameSetting
    gameSound && buttonClickAudio?.play()
    openSuccessToaster({ message: 'Bet Placed Successfully' })
    onSuccess(res)
    return res
  } catch (error) {
    openErrorToaster({ message: 'Place Bet Failed' })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const openCardHiLo = createAsyncThunk('hi-lo-game/open-card', async ({ data, setBetAmount, minBetData, betAmount, handleChangeMainCard }, thunkApi) => {
  try {
    const res = await openCardHiLoService(data)
    const card = document.querySelector('.card-center')

    card.classList.toggle('flipped')
    const openedCard = res.betStates[res.betStates.length - 1].openedCard
    if (res?.result === BET_RESULT.LOST) {
      openErrorToaster({ message: 'Lost' })
      thunkApi.dispatch(setServerSeedHash(res?.serverSeed))
      thunkApi.dispatch(resetCalculatedProfits({
        currentCardIndex: openedCard
      }))
    } else {
      thunkApi.dispatch(setCalculatedProfits({
        currentCardIndex: openedCard,
        coefficient: res.betStates[res.betStates.length - 1].coefficient,
        betAmount
      }))
    }
    handleChangeMainCard(openedCard)
    return res
  } catch (error) {
    console.log('CATCH ERROR', error)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBetsHiLo = createAsyncThunk('hi-lo-game/my-bets', async (data, thunkApi) => {
  try {
    const res = await myBetsHiLoService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cashOutHiLo = createAsyncThunk('hi-lo-game/cash-out-bet', async ({ payload }, thunkApi) => {
  try {
    const { data, cashoutAudio, onSuccess } = payload
    const res = await cashOutBetHiLoService(data)
    thunkApi.dispatch(setServerSeedHash(res?.serverSeed))
    const { gameSound } = thunkApi?.getState()?.gameSetting
    gameSound && cashoutAudio?.play()
    onSuccess(res)
    return res
  } catch (error) {
    openErrorToaster({ message: 'Cash Out Failed' })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getUnfinishedBet = createAsyncThunk('hi-lo-game/get-unfinished-bet', async (_, thunkApi) => {
  try {
    const res = await getUnfinishedBetService()
    if (res?.hasUnfinishedBet) {
      let coefficient = 1
      let currentCardIndex
      openSuccessToaster({ message: 'You already have a Bet Placed.' })
      const betStates = res.unfinishedBet.betStates
      const betAmount = res.unfinishedBet.betAmount
      if (betStates.length) {
        coefficient = betStates[betStates.length - 1].coefficient
        currentCardIndex = betStates[betStates.length - 1].openedCard
      } else {
        currentCardIndex = res.unfinishedBet.initialCard
      }
      thunkApi.dispatch(setCalculatedProfits({
        currentCardIndex,
        betAmount,
        coefficient
      }))
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
